import { del, get, post, put, upload } from "./api";
import { err, ok, Result } from "../result";
import { ProblemDetails } from "../models/Http";
import { Segment, SegmentRule } from "../models/Segment";
import { LifvsUser } from "../models/User";

export const list = async (): Promise<
  Result<ProblemDetails, ReadonlyArray<Segment>>
> => {
  const response = await get("/v1/segments");
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<Segment>);
  }

  return err(content as ProblemDetails);
};

export const listUsers = async (
  id: string
): Promise<Result<ProblemDetails, ReadonlyArray<LifvsUser>>> => {
  const response = await get(`/v1/segments/${id}/users`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<LifvsUser>);
  }

  return err(content as ProblemDetails);
};

export const listRules = async (): Promise<
  Result<ProblemDetails, ReadonlyArray<SegmentRule>>
> => {
  const response = await get("/v1/segments/rules");
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<SegmentRule>);
  }

  return err(content as ProblemDetails);
};

export const add = async (
  name: string,
  rules: SegmentRule[]
): Promise<Result<ProblemDetails, any>> => {
  const rulesFormatted = rules.reduce((acc: any, curr) => {
    acc.push({ ...curr, parameterData: curr.parameters });
    return acc;
  }, []);
  const response = await post("/v1/segments", { name, rules: rulesFormatted });
  const content = await response.json();

  if (!response.ok) {
    return err(content as ProblemDetails);
  }

  return ok(content);
};

export const update = async (
  id: string,
  name: string,
  rules: SegmentRule[]
): Promise<Result<ProblemDetails, any>> => {
  const rulesFormatted = rules.reduce((acc: any, curr) => {
    acc.push({ ...curr, parameterData: curr.parameters });
    return acc;
  }, []);
  const response = await put(`/v1/segments/${id}`, {
    name,
    rules: rulesFormatted
  });

  if (!response.ok) {
    const content = await response.json();
    return err(content as ProblemDetails);
  }

  return ok({});
};

export const remove = async (
  id: string
): Promise<Result<ProblemDetails, any>> => {
  const response = await del(`/v1/segments/${id}`);

  if (!response.ok) {
    const content = await response.json();
    return err(content as ProblemDetails);
  }

  return ok({});
};

export const uploadUsers = async (
  id: string,
  file: Blob
): Promise<Result<ProblemDetails, any>> => {
  const response = await upload(`/v1/segments/${id}/users`, file);

  if (!response.ok) {
    const content = await response.json();
    return err(content as ProblemDetails);
  }

  return ok({});
};

export const addUser = async (
  id: string,
  userEmail: string
): Promise<Result<ProblemDetails, any>> => {
  const response = await post(
    `/v1/segments/${id}/users/add?userEmail=${userEmail}`
  );

  if (!response.ok) {
    const content = await response.json();
    return err(content as ProblemDetails);
  }

  return ok({});
};
